// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3BZ8V","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1TI6w"};